import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

import { af, backLinkCss } from '../theme';

const styles = {
  root: css`
    margin-top: ${af.sp4};
    text-align: center;
  `,
  button: backLinkCss,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
